import useExport from '@/composables/export/export';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { viewType } from 'shared/constants.json';

export default function useLoadLimit(savedView) {
  const { t } = useI18n();
  const { isPrint } = useExport();

  const loadLimitOptions = [
    { text: '10', value: 10 },
    { text: '25', value: 25 },
    { text: '50', value: 50 },
    { text: '100', value: 100 },
  ];

  const loadLimitLabel = computed(() => {
    if ([viewType.cascade, viewType.tree, viewType.atlas].includes(savedView.value.viewType)) {
      return t('documentListHeader.loadLimitRoot');
    }
    return t('documentListHeader.loadLimit');
  });

  const loadLimit = computed(() => {
    if (isPrint.value) {
      return 500;
    }

    if (savedView.value.params?.loadLimit !== undefined) {
      return savedView.value.params.loadLimit;
    }
    if ([viewType.cascade, viewType.tree, viewType.atlas].includes(savedView.value.viewType)) {
      return 10;
    }
    return 25;
  });

  const renderedItemsLimit = computed(() => {
    if (isPrint.value) {
      // Assuming that goals have an average of 3 children.
      return loadLimit.value * 3;
    }

    if ([viewType.cascade, viewType.tree, viewType.atlas].includes(savedView.value.viewType)) {
      return 25;
    }
    return loadLimit.value;
  });

  return { loadLimitOptions, loadLimit, loadLimitLabel, renderedItemsLimit };
}
